import BasePage from "@Scripts/Pages/BasePage";

export default class MyBeghelliPage extends BasePage {
    public static async init() {
        await super.init();

        this.setHeader();
    }

    private static setHeader() {
        if ((<any>window).App.bag.area) {
            let box = <any>document.querySelector(".menucontextual >.buttons >.wrapper");
            let page = document.querySelector(".menucontextual >.buttons >.wrapper >.button[data-area=\"" + (<any>window).App.bag.area + "\"]");
            page.classList.add("selected");

            box.scrollLeft = (<any>page).offsetLeft - box.offsetLeft - 50;
        }

        if ((<any>window).App.bag.page) {
            let box = <any>document.querySelector(".aside");
            var page = document.querySelector(".aside >.button[data-page=\"" + (<any>window).App.bag.page + "\"]");
            page.classList.add("selected");

            box.scrollLeft = (<any>page).offsetLeft - box.offsetLeft - 50;
        }

        if ((<any>window).App.bag.area === "Document") {
            var page = document.querySelector(".container >.aside >.button[data-category=\"" + (<any>window).App.bag.type + "\"]");
            page.classList.add("selected");
        }
    }
}